var EPK = EPK || {};
EPK.ProductShopLaw = EPK.ProductShopLaw || {};
EPK.ProductShopLaw = function() {};

$(function(){
	$('#close-window-btn').on('click', function() {
		window.close();
	});
});

